module.exports = __webpack_public_path__ + "NewCampus-be2ad258.webp";